{
	"postTrading": {
		"option": "Option",
		"options": "Options",
		"stocks": "Stocks",
		"sum": "Amount",
		"price": "Price",
		"event": "Event",
		"date": "Date"
	}
}
